/*
 * Copyright (c) 2021 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import * as t from './actionTypes';

const INITIAL_STATE = {
  allIds: [],
  byId: {}
};

/**
 * This reducer updates the 'applications' strand of the Redux state, which consists of the following:
 *
 * 1) 'byId': A map of applications, keyed by application ID.  This is simply a cache of all the applications
 * the app is currently aware of.
 *
 * 2) 'allIds': The set of the IDs of all applications in the current result set. It is updated when
 * the collection of applications is fetched.
 *
 */
const applicationsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    /**
     * Replace the entire list of domain applications with a new list.
     */
    case t.LIST_APPLICATIONS_REQUEST_COMPLETE: {
      return pushResults(state, action.applications);
    }

    default:
      return state;
  }
};

/**
 * Helper function to push an application onto the result list (and also into the
 * set of entities).
 */
function pushResult (state, app) {
  if (state.byId[app.id]) {
    return state;
  } else {
    return {
      ...setEntity(state, app),
      allIds: [
        ...state.allIds,
        app.id
      ]
    };
  }
}

/**
 * Helper function to push a series of applications onto the result list (and also
 * into the set of entities). Clear the current list and rebuild
 */
function pushResults (state, applications) {
  state.byId = [];
  state.allIds = [];
  return applications.reduce(pushResult, state);
}

/**
 * Helper function to add an entity to the set of cached entities.
 */
function setEntity (state, app) {
  return {
    ...state,
    byId: {
      ...state.byId,
      [app.id]: app
    }
  };
}

export default applicationsReducer;



// WEBPACK FOOTER //
// ./src/applications/reducer.js